import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class SupplierService {
    _baseUrl: string;

    constructor(private _httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._baseUrl = baseUrl;
    }

    getSuppliers(section?: SupplierSection): Observable<ISupplierResult> {
        const requestUrl = this._baseUrl + 'api/kweker/getSuppliers';

        let param: any;
        if (section != null) {
            param = { 'forSection': section };
        }

        return this._httpClient.get<ISupplierResult>(requestUrl, { params: param });
    }
}

export interface ISupplierResult {
    items: ISupplier[];
    totalCount: number;
}

export interface ISupplier {
    name: string;
    ean: number;
    selected: boolean;
    isNameUnique: boolean;
}

export enum SupplierSection {
    regels = 0,
    labels = 1
}